/**
 * ADR-052 (этап II): исходящие webhooks — подписки и журнал доставок. Здесь
 * только контракты (browser-safe): сами хранилище и движок доставки живут в core.
 */
/** Префикс signing-секрета подписки (`whsec_<base64url>`). */
export const WEBHOOK_SECRET_PREFIX = 'whsec_';
/**
 * Дефолтный набор паттернов событий подписки (пустой `events` = этот набор).
 * Паттерн — точный тип (`stream.done`) либо префикс `prefix.*` (`session.*`).
 * Набор намеренно исключает высокочастотный стриминг (`stream.chunk`/`usage`),
 * оставляя интеграционно значимые вехи: жизненный цикл сессий, сообщения,
 * завершение/ошибка стрима, план/todo, проект, файлы и события Router.
 */
export const DEFAULT_WEBHOOK_EVENT_PATTERNS = [
    'session.*',
    'message.added',
    'stream.done',
    'stream.error',
    'plan.approved',
    'todos.updated',
    'project.updated',
    'fs.changed',
    'event.*',
    'binding.changed',
];
/**
 * Проверяет, матчит ли тип события список паттернов подписки.
 * Пустой/отсутствующий список — дефолтный набор (`DEFAULT_WEBHOOK_EVENT_PATTERNS`).
 * Паттерн `foo.*` матчит любой тип, начинающийся с `foo.`; иначе — точное совпадение.
 */
export function matchWebhookEvent(patterns, eventType) {
    const list = patterns && patterns.length > 0 ? patterns : DEFAULT_WEBHOOK_EVENT_PATTERNS;
    for (const pattern of list) {
        if (pattern.endsWith('.*')) {
            if (eventType.startsWith(pattern.slice(0, -1)))
                return true;
        }
        else if (pattern === eventType) {
            return true;
        }
    }
    return false;
}
/** Формат паттерна события: `foo.bar` либо `foo.*` (без пробелов/пустых сегментов). */
export function isWebhookEventPattern(value) {
    const pattern = value.trim();
    if (!pattern)
        return false;
    if (pattern.endsWith('.*')) {
        return /^[a-z0-9_]+(\.[a-z0-9_]+)*\.\*$/.test(pattern);
    }
    return /^[a-z0-9_]+(\.[a-z0-9_]+)+$/.test(pattern);
}
